import { DataGridPro, GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { useMediaQuery, useTheme } from '@mui/material';
import { streetTurnColumnDefinitions, mobileStreetTurnColumnDefs } from './columns';
import { applyThemeGridSxOverrides } from '@/Infrastructure/Theme/AppThemeOverrides';
import { StreetTurn } from '@api/Trinium/Endpoints/StreetTurn/types';
import { GenericOverlay } from '@components/DataGrid/GenericNoRowsOverlay';
import { StreetTurnDataGridProps } from '@components/DataGrid/types';
import StreetTurnGridToolbar from './GridToolbar';

import styles from '@components//DataGrid/RenderCell.module.css';

/**
 * MUI Data Grid Pro component for Street Turn.
 */
export default function Grid({ rows, onRowSelect }: StreetTurnDataGridProps) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	function onSingleRowSelect(rowSelectionModel: GridRowSelectionModel) {
		if (rowSelectionModel.ids.size > 0) {
			const [, selectedRowId] = rowSelectionModel.ids.entries().next().value as [never, GridRowId];

			const selectedRow = rows.find((t) => t.legId === selectedRowId);

			if (selectedRow) {
				/** Execute the callback */
				onRowSelect(selectedRow);
			}
		} else {
			onRowSelect(null);
		}
	}

	return (
		<DataGridPro
			columns={isMobile ? mobileStreetTurnColumnDefs : streetTurnColumnDefinitions}
			getRowId={(row: StreetTurn) => row.legId}
			checkboxSelection={true}
			disableMultipleRowSelection={true}
			onRowSelectionModelChange={onSingleRowSelect}
			columnHeaderHeight={50}
			rowHeight={isMobile ? 200 : 50}
			rows={rows}
			className={styles['custom-data-grid']}
			getRowClassName={(props) => (props.indexRelativeToCurrentPage % 2 ? styles['alternate-row'] : '')}
			slots={{
				toolbar: StreetTurnGridToolbar,
				noRowsOverlay: () => <GenericOverlay overlayText='No ECL Import orders eligible for Street Turn meet the criteria at this time.' />,
				noResultsOverlay: () => <GenericOverlay overlayText='No Results Found.' />
			}}
			sx={{
				...applyThemeGridSxOverrides(),
				'& .MuiDataGrid-columnHeaders': isMobile
					? {
							display: 'none'
						}
					: {}
			}}
		/>
	);
}
